import { Reveal } from "./Reveal";

const WESTERN_PA = [
  "Sharon", "Hermitage", "Farrell", "Sharpsville", "Wheatland",
  "West Middlesex", "Greenville", "Grove City", "Mercer", "New Castle",
  "Ellwood City", "Meadville",
];

const NORTHEASTERN_OH = [
  "Warren", "Niles", "Girard", "Hubbard", "Cortland", "Newton Falls",
  "Lordstown", "McDonald", "Youngstown", "Austintown", "Boardman", "Canfield",
];

const CityColumn = ({ title, cities, testid }) => (
  <div data-testid={testid}>
    <p className="border-b border-royal-dark/20 pb-3 font-mono text-xs font-bold uppercase tracking-[0.25em] text-royal-dark">
      {title}
    </p>
    <ul className="divide-y divide-royal-dark/10">
      {cities.map((city) => (
        <li
          key={city}
          data-testid={`area-city-${city.toLowerCase().replace(/\s+/g, "-")}`}
          className="py-2.5 text-sm font-medium text-royal-dark sm:text-base"
        >
          {city}
        </li>
      ))}
    </ul>
  </div>
);

export const ServiceArea = () => (
  <section
    id="area"
    data-testid="service-area-section"
    className="border-t border-black/10 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-4xl px-6 text-center">
      <Reveal>
        <h2 className="text-3xl font-bold text-royal-dark sm:text-4xl" data-testid="service-area-title">
          Service Area
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div
          data-testid="service-area-cities"
          className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-x-12 text-left"
        >
          <CityColumn
            title="Northeastern Ohio"
            cities={NORTHEASTERN_OH}
            testid="area-col-northeastern-ohio"
          />
          <CityColumn
            title="Northwestern Pennsylvania"
            cities={WESTERN_PA}
            testid="area-col-western-pa"
          />
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-10 text-sm font-medium text-royal-dark">
          …and all surrounding communities.
        </p>
      </Reveal>
    </div>
  </section>
);
